import React from 'react';
import { View, ViewProps } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import styles from './header.style';

interface HeaderProps extends ViewProps {
  color: string;
  children: any;
}

export function Header({ color = '#444', children }: HeaderProps) {
  return (
    <SafeAreaView edges={['top']}>
      <View style={[styles.container, { backgroundColor: color }]}>{children}</View>
    </SafeAreaView>
  );
}
